import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { KeyEventUtil } from 'utils'

const TituloFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-tipoDocumento', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='TITULO' htmlFor='input-titulo' md={3} alignRightAt='md' />
      <Col md={9}>
        <Field name='titulo'>
          {({ field }) => (
            <Form.InputText
              {...field}
              id='input-titulo'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TituloFormGroup)
